import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/auth/use-auth';
import UiLoader from '@/ui/UiLoader/UiLoader';
import UiPhone from '@/ui/UiPhone/UiPhone';
import UiCode from '@/ui/UiCode/UiCode';

const LoginLite = () => {
  const [phone, setPhone] = React.useState<string>('');
  const { status, isLoading } = useAuth();
  const navigate = useNavigate();

  React.useLayoutEffect(() => {
    if (status === 'success') {
      navigate('/');
    }
  }, [navigate, status]);

  const handlePhoneSubmit = (source: string) => {
    setPhone(source);
  };

  if (isLoading) {
    return <UiLoader />;
  }

  if (status === 'code') {
    return <UiCode phone={phone} />;
  }

  return <UiPhone onSubmit={handlePhoneSubmit} />;
};

export default LoginLite;
